export enum UserRole {
  Admin = 'USER_ROLE_ADMIN',
  SuperAdmin = 'USER_ROLE_SUPER_ADMIN',
  JcEmployee = 'USER_ROLE_JC_EMPLOYEE',
}
